import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type PostLoginRedirectState = {
  /** Same-app path (`/admin/...` or `/users/...`) to open after successful login. */
  path: string | null;
};

const initialState: PostLoginRedirectState = {
  path: null,
};

const postLoginRedirectSlice = createSlice({
  name: 'postLoginRedirect',
  initialState,
  reducers: {
    setPendingPostLoginRedirect(state, action: PayloadAction<string>) {
      state.path = action.payload;
    },
    clearPendingPostLoginRedirect() {
      return initialState;
    },
  },
});

export const { setPendingPostLoginRedirect, clearPendingPostLoginRedirect } =
  postLoginRedirectSlice.actions;
export default postLoginRedirectSlice.reducer;
